import EmojiPickerPopper from './poppers/emoji-picker-popper'
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { labelActions } from '@common-reducers/labels-reducer'
import LabelInput from './label-input'
import { cn } from '@/lib/utils'


type Props = {
    disabled?: boolean
}

export default function LabelForm({ disabled }: Props) {
    const dispatch = useAppDispatch()
    const label = useAppSelector((state) => state.LabelReducer.label)
    return (
        <div className={cn(
            "group h-[46px] flex items-center rounded-lg border border-gray-200 bg-white transition-all duration-200 dark:bg-slate-800 dark:border-slate-700",
            "hover:border-blue-400 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500/20 dark:hover:border-blue-500",
            disabled && "opacity-60 bg-gray-50 hover:border-gray-200 cursor-not-allowed dark:bg-slate-900"
        )}>
            <div className="flex-shrink-0 relative z-[10001] dark:[&_button]:border-slate-700 dark:[&_button]:text-gray-300 dark:[&_button:hover]:text-[#546eff] dark:[&_svg]:text-current">
                <EmojiPickerPopper label={label} disabled={disabled} />
            </div>
            <LabelInput
                value={label.name ?? ''}
                disabled={disabled}
                onChange={({ target }: any) => dispatch(labelActions.setLabel({ ...label, name: target.value }))}
                placeholder='Type name here...'
                className="border-0 focus-visible:ring-0 focus-visible:ring-offset-0 px-3 h-full rounded-r-lg"
            />
        </div>
    )
}

